import Vue from 'vue';

export interface IVideosInfo {
  title: string;
  subtitle: string;
  link: string;
  moduleName: string;

  [key: string]: any;
}

export const Videos: IVideosInfo[] = Vue.observable([
  {
    title: 'Productos',
    subtitle: 'productsSubtitle',
    link: 'https://www.youtube.com/embed/O2uVL0iOyU8?si=dxOV-D5U0RWn07Uo',
    moduleName: 'products',
  },
  {
    title: 'Categorías',
    subtitle: 'categoriesSubtitle',
    link: 'https://www.youtube.com/embed/O2uVL0iOyU8?si=dxOV-D5U0RWn07Uo',
    moduleName: 'categories',
  },
  {
    title: 'Mesas',
    subtitle: 'tablesSubtitle',
    link: 'https://www.youtube.com/embed/4k3a7DpvuKs?si=hftmhk6i_q2qKT1y',
    moduleName: 'tables',
  },
  {
    title: 'Zonas',
    subtitle: 'zonesSubtitle',
    link: 'https://www.youtube.com/embed/4k3a7DpvuKs?si=jJG0xZ2HsCZj3sjJ',
    moduleName: 'zones',
  },
  {
    title: 'Pantallas',
    subtitle: 'screensSubtitle',
    link: 'https://www.youtube.com/embed/Uy7XW3XTr3g?si=eeJN9FTtMg5-N15w',
    moduleName: 'screens',
  },
  {
    title: 'Premios',
    subtitle: 'awardsSubtitle',
    link: '',
    moduleName: 'awards',
  },
  {
    title: 'Empleados',
    subtitle: 'employeesSubtitle',
    link: '',
    moduleName: 'employees',
  },
  {
    title: 'Clientes',
    subtitle: 'clientsSubtitle',
    link: '',
    moduleName: 'clients',
  },
  {
    title: 'Impresoras',
    subtitle: 'printersSubtitle',
    link: 'https://www.youtube.com/embed/voxf0im28w8?si=aYp4AsKOY9aAsEq3',
    moduleName: 'printers',
  },
  {
    title: 'Cajón',
    subtitle: 'cashiersSubtitle',
    link: '',
    moduleName: 'cashiers',
  },
  {
    title: 'Familias',
    subtitle: 'familiesSubtitle',
    link: 'https://www.youtube.com/embed/Hnq9T7x92bk?si=Ef8D5wtXL1bCFaf9',
    moduleName: 'families',
  },
  {
    title: 'Cierre de caja',
    subtitle: 'boxReportSubtitle',
    link: 'https://www.youtube.com/embed/Yrm44rCj8Uk?si=dOy7GYKnvH_yH04i',
    moduleName: 'box_report',
  },
  {
    title: 'Turnos',
    subtitle: 'shiftsSubtitle',
    link: '',
    moduleName: 'shifts',
  },
  {
    title: 'Opciones',
    subtitle: 'bookingOptionsSubtitle',
    link: '',
    moduleName: 'booking-options',
  },
  {
    title: 'Calendario',
    subtitle: 'bookingsSubtitle',
    link: '',
    moduleName: 'bookings',
  },
  {
    title: 'Reportes',
    subtitle: 'reportsSubtitle',
    link: '',
    moduleName: 'reports',
  },
  {
    title: 'Configuraciones',
    subtitle: 'settingsSubtitle',
    link: '',
    moduleName: 'settings',
  },
  {
    title: 'Stock',
    subtitle: 'stockReportSubtitle',
    link: '',
    moduleName: 'stock_report',
  },
  {
    title: 'Escandallos',
    subtitle: 'recipesSubtitle',
    link: '',
    moduleName: 'recipes',
  },
  {
    title: 'Compras',
    subtitle: 'purchasesSubtitle',
    link: '',
    moduleName: 'purchases',
  },
  {
    title: 'Almacenes',
    subtitle: 'stockSubtitle',
    link: '',
    moduleName: 'stock',
  },
  {
    title: 'Proveedor',
    subtitle: 'providerSubtitle',
    link: '',
    moduleName: 'provider',
  },
  {
    title: 'Ingredientes',
    subtitle: 'ingredientsSubtitle',
    link: '',
    moduleName: 'ingredients',
  },
  {
    title: 'Modificadores',
    subtitle: 'modifiersSubtitle',
    link: 'https://www.youtube.com/embed/LIZGnvAIWK0',
    moduleName: 'modifiers',
  },
]);
